﻿import { sendDataLayer } from "./ecommerce";

document.addEventListener("DOMContentLoaded", () =>
{
    sendCustomBlockEvents();
});


const sendCustomBlockEvents = () =>
{
    if ($(".js-custom-block").length > 0)
    {
        var customblockid = $(".js-custom-block").data("customblockid");
        var customblocktitle = $(".js-custom-block").data("title");
        var customblockimage = $(".js-custom-block-image").attr('src');
        var customblockdate = $(".js-custom-block").data("blockdate");

        var promotionID = 'aangepast_blok';
        if (typeof (customblockid) != typeof (undefined))
            promotionID += '_' + + customblockid
        else if (typeof (customblocktitle) != typeof (undefined))
            promotionID += '_' + + customblocktitle

        var promotionName = '';

        if (typeof (customblockdate) != typeof (undefined))
            promotionName = customblockdate;

        if (typeof (customblocktitle) != typeof (undefined))
            promotionName += customblocktitle;

        onScrolledIntoView($(".js-custom-block"), function ()
        {
            sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
            sendDataLayer({
                'event': 'promotionView',
                'ecommerce': {
                    'items': [{													// Array of promoFieldObjects.
                        'promotion_id': promotionID,		                    // ID or Name is required.
                        'promotion_name': promotionName,
                        'creative_name': customblockimage,
                        'creative_slot': 'banner_slot2',
                        'google_business_vertical': 'retail'
                    }]
                }
            });
        });

        $(".js-custom-block-link").on('click', function ()
        {
            sendDataLayer({ ecommerce: null });  // Clear the previous ecommerce object.
            sendDataLayer({
                'event': 'promotionClick',
                'ecommerce': {
                    'items': [{													// Array of promoFieldObjects.
                        'promotion_id': promotionID,		                    // ID or Name is required.
                        'promotion_name': promotionName,
                        'creative_name': customblockimage,
                        'creative_slot': 'banner_slot2',
                        'google_business_vertical': 'retail'
                    }]
                }
            });
        });
    }
}